import { Injectable } from '@angular/core';
import { WarehouseInventoryService } from '@ups/xplat/api/services';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchSalesOrderService {
  constructor(public warehouseInventoryService: WarehouseInventoryService) {}

  search(searchString: string) {
    return this.warehouseInventoryService.salesOrders$.pipe(
      map((salesOrders) => {
        const foundSalesOrders = salesOrders
          .filter(
            (salesOrder) =>
              salesOrder.orderNumber
                .toLowerCase()
                .indexOf(searchString.toLowerCase()) > -1
          )
          .filter((salesOrder, index) => index < 50)
          .sort((a, b) => a.orderNumber.localeCompare(b.orderNumber));

        return foundSalesOrders;
      })
    );
  }
}
